import http from "./httpService";
import auth from "./authService";
import { StreamApiBase, StreamKey } from "../utils/constants";

http.setJwt(auth.getJwt());

// One call for all four streams — the only difference is the route prefix, so the
// Ranges tab does not need a per-stream service.
export const getTicketRanges = (
  stream: StreamKey,
  params?: { isBSeries?: boolean; from?: number; to?: number }
) => {
  const query = new URLSearchParams();
  if (params?.isBSeries !== undefined)
    query.set("isBSeries", String(params.isBSeries));
  if (params?.from !== undefined) query.set("from", String(params.from));
  if (params?.to !== undefined) query.set("to", String(params.to));

  const qs = query.toString();
  return http.get(`${StreamApiBase[stream]}/ranges${qs ? `?${qs}` : ""}`);
};

export default { getTicketRanges };
